<div class="outer-container">

    <div fxLayout="row" fxLayoutAlign="space-between">
      <div class="sub-title" >Login</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center" class="background-white">
      <div fxLayout="column" fxLayoutAlign="center">
        <form
          class="example-form account-form"
          #accountForm="ngForm"
          autocomplete="off"
          (keydown)="EnterSubmit($event)"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="row-padded first-row"
          >
          </div>

          <mat-form-field class="example-full-width">
              <input
                matInput
                placeholder="Email"
                [(ngModel)]="createAccount.Email"
                name="Email"
                #Email="ngModel"
                required
              />
              <mat-error
                *ngIf="
                  Email.invalid &&
                  (Email.dirty || Email.touched) &&
                  Email.errors.pattern
                "
              >
                Please enter your email address
              </mat-error>
              <mat-error
                *ngIf="
                  Email.invalid &&
                  (Email.dirty || Email.touched) &&
                  Email.errors.required
                "
              >
                Email is required
              </mat-error>
            </mat-form-field>
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class=""
          >
            <mat-form-field class="example-full-width">
              <input
                matInput
                placeholder="Password"
                [type]="passwordHide ? 'password' : 'text'"
                [(ngModel)]="createAccount.Password"
                name="Password"
                autocomplete="new-password"
                minlength="8" required
                #Password="ngModel"
              />
              <mat-icon matSuffix (click)="passwordHide = !passwordHide">{{
                passwordHide ? "visibility" : "visibility_off"
              }}</mat-icon>
              <mat-error *ngIf="Password.errors && Password.errors.minlength">
                Minimum 8 characters required
              </mat-error>
              <mat-error
                *ngIf="
                  Password.invalid &&
                  (Password.dirty || Password.touched) &&
                  Password.errors.required
                "
              >
                Password is required
              </mat-error>
            </mat-form-field>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="form-key example-full-width"
          >
            <div>
              <button
                class="primary-button button example-full-width"
                
                type="button"
                (click)="login()"
              >
                Login
              </button>
              
            </div>
          </div>

        </form>
        <div class="registerWrapper">
          <div>
            Don't have an account?
          </div>
          <div>
            <button
              class="register-button button"
              mat-button
              type="button"
              (click)="createNewAccount()"
            >Take a Free Diagnostic Exam
            </button>
          </div>
          <div>
            or
          </div>
          <div>
            <button
              class="register-button button"
              mat-button
              type="button"
              (click)="createNewAccount()"
            >Register Now
            </button>
          </div>
        </div>
      </div>
      
    </div>

  </div>
  
